//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavAIChatbot(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.99999 2H2V6.99999H6.99999V2Z" fill="currentColor" /><path d="M21.9997 12H2.00049V17H21.9997V12Z" fill="currentColor" /><path d="M21.9997 12L7 12L6.99999 6.99999L12 7V2H22L21.9997 12Z" fill="currentColor" /><path d="M6.99951 22V17H11.9995L6.99951 22Z" fill="currentColor" /></svg>;
}
export default IconNavAIChatbot;